(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('PersistentAuditEvent', PersistentAuditEvent);

  PersistentAuditEvent.$inject = ['$resource', 'DateUtils', 'API_URI'];

  function PersistentAuditEvent($resource, DateUtils, API_URI) {
    var resourceUrl = API_URI + 'api/contacts/:id';
    return $resource(resourceUrl, {}, {
      'getPersistenceAuditEvents': {
        url: API_URI + 'api/cards/persistentAuditEvents/:userId',
        method: 'GET',
        isArray: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      }
    });
  }
})();
